export default "__VITE_ASSET__BYIgcQDs__"